import React from 'react'
import { Modal, Button } from 'react-bootstrap'
function ModalAlert({message,  
    visible,
    onConfirm
    ,}) {
  
  return (
    <>
      <Modal show={visible}>
        <Modal.Header closeButton onClick={onConfirm} style={{backgroundColor:'#fff'}}>
          <Modal.Title>Message</Modal.Title>
        </Modal.Header>
        <Modal.Body>
         {message}
        </Modal.Body>
        <Modal.Footer>
          <Button style={{backgroundColor:'#0072BC',borderColor:'#0072BC'}} onClick={onConfirm}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  )
}
export default ModalAlert